export default [
  {
    path: '/',
    name: 'consultation',
    component: () => import('@/components/form/form-consultation.vue')
  }
]